import React from "react";
import { Routes, Route } from "react-router-dom";
import { Genia } from "~/pages/Genia";

export const Public = () => {
  return (
    <Routes>
      <Route path="*" element={<Genia />} />
    </Routes>
  );
}
